import React from 'react';
import { Box, Grid } from '@mui/material';
import { HeaderItems, StyledAppBar, StyledToolbar } from './header.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Header = function Header() {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(StyledAppBar, {
      color: "transparent",
      elevation: 0,
      children: /*#__PURE__*/_jsx(StyledToolbar, {
        disableGutters: true,
        children: /*#__PURE__*/_jsxs(Grid, {
          container: true,
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
          children: [/*#__PURE__*/_jsx(Box, {}), /*#__PURE__*/_jsx(HeaderItems, {
            children: "123"
          })]
        })
      })
    })
  });
};

export { Header };